import DeliveryQualityInspectionCard from '@/models/DeliveryQualityInspection/DeliveryQualityInspectionCard';

export default class DeliveryQualityInspectionCardFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.deliveryQualityInspectionId  = '';
		this.deliveryQualityInspectionDeliveryQualityInspectionNo = '';
		this.deliveryQualityInspectionDetailId  = '';
		this.deliveryQualityInspectionDetailPart = '';
		this.deliveryCardId  = '';
		this.deliveryCardDeliveryCardNumber = '';
		this.qcStatusId  = '';
		this.qcStatusName = '';
		this.remarksMultiple = '';
		this.qcDateFrom = '';
		this.qcDateTo = '';
		this.qcById  = '';
		this.qcByFirstName = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			deliveryQualityInspectionId : '0',
			deliveryQualityInspectionDeliveryQualityInspectionNo : '0',
			deliveryQualityInspectionDetailId : '0',
			deliveryQualityInspectionDetailPart : '0',
			deliveryCardId : '0',
			deliveryCardDeliveryCardNumber : '0',
			qcStatusId : '0',
			qcStatusName : '0',
			remarksMultiple : '0',
			qcDateFrom : '0',
			qcDateTo : '0',
			qcById : '0',
			qcByFirstName : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}